import { useStyles } from '@webapps/styles';
import { useState } from 'react';
import { Share } from '@material-ui/icons';
import { Button } from '@material-ui/core';
import CFARouterBis from 'components/Icons/CFARouterBis';
import ModalOpco from './ModalOpco';
import { formatDate224 } from '@webapps/utils';
import { InfoTooltip } from '@webapps/styles';

export default function Opco({ stat }) {
  const { classes, global, cx } = useStyles(styles);

  const [open, setOpen] = useState(false);

  return (
    <div className={classes.card}>
      <CFARouterBis className={classes.image} />
      <div className={classes.content}>
        <div className={classes.header}>
          <div className={cx(global.title, global.ellipsis)}>{`${stat?.count || 0} / 11 OPCOs`}</div>
          <InfoTooltip
            position="bottom"
            forceVisible={false}
            title="Comment ça marche ?"
            description="Connectez les différents OPCO pour déposer et suivre vos dossiers d'alternance et d'apprentissage sur Linkpick."
            link={{ text: "En savoir plus" }}
          />
        </div>
        <div className={classes.date}>{`Dernière modification ${formatDate224(stat?.lastUpdate)}`}</div>
        <Button className={global.buttonCFADashboard} onClick={() => setOpen(true)}>
          <div className={global.buttonCFADashboardText}>Gérer les connexions</div>
        </Button>
      </div>
      <ModalOpco open={open} onCancel={() => setOpen(false)} />
    </div>
  );
}

const styles = ({ spacing }) => ({
  card: {
    alignItems: 'center',
    backgroundColor: '#ffffff',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,
    padding: '20px',
    gap: '20px',
    overflow: 'visible',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    overflow: 'visible',
  },
  image: {
    width: '65px',
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    gap: '6px',
    overflow: 'visible',
  },
  date: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '12px',
    lineHeight: '12px',
    color: '#5d75a8',
  },
});